module.exports = __webpack_public_path__ + "img/1762152292515-diOWDDsE.fcb5e5a2.png";